import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetAllTaskItemsDto, queryKeys, useAccessToken } from "src/http";

const useGetAllTaskItemsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getAllTaskItemsRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.taskItems.getAllTaskItems>>): Promise<GetAllTaskItemsDto> {
    const accessToken = await getAccessToken();
    const [{ taskItemGuid }] = queryKey;
    const urlSearchParams = new URLSearchParams();

    if (taskItemGuid) {
      urlSearchParams.append("taskItemGuid", taskItemGuid);
    }

    const response = await fetch(`${configuration.apiRootUrl}/task-items?${urlSearchParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getAllTaskItemsRequest };
};

const useGetAllTaskItems = (taskItemGuid: string | undefined) => {
  const { getAllTaskItemsRequest } = useGetAllTaskItemsRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getAllTaskItems(taskItemGuid),
    queryFn: getAllTaskItemsRequest,
  });
};

export { useGetAllTaskItems };
